import React from 'react';
import { Container, Row, Col } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faCheckCircle,
  faRobot,
  faRocket,
  faWrench,
  faBrain,
  faHandshake,
} from '@fortawesome/free-solid-svg-icons';
import TeamImage from '../images/why-us-visual.png';
import './style.css';

const items = [
  {
    icon: faWrench,
    text: 'Tailored solutions — no generic templates.',
  },
  {
    icon: faRobot,
    text: 'Real AI implementation, not just trends.',
  },
  {
    icon: faRocket,
    text: 'Focused on conversion, speed, and scalability.',
  },
  {
    icon: faBrain,
    text: 'Strategy comes before execution.',
  },
  {
    icon: faHandshake,
    text: 'Close support and transparent communication.',
  },
];

function WhyChooseUsSection() {
  return (
    <section id="why-choose-us" className="whychooseus-section">
      <Container>
        <Row className="align-items-center">
          {/* Left - Text content */}
          <Col md="6">
            <div className="whychooseus-overline">
              Why Choose Us
            </div>
            <h2 className="whychooseus-title">
              Why <span className="whychooseus-highlight">Trust Us</span> With Your Digital Growth
            </h2>
            <p className="whychooseus-description">
              We’re not just another agency. We combine technology, creativity, and
              empathy to build real results with a human touch.
            </p>
            <ul className="whychooseus-list">
              {items.map(({ icon, text }, index) => (
                <li key={index} className="whychooseus-list-item">
                  <FontAwesomeIcon
                    icon={faCheckCircle}
                    className="whychooseus-list-icon"
                  />
                  <span className="whychooseus-list-text">{text}</span>
                </li>
              ))}
            </ul>
          </Col>

          {/* Right - Transparent PNG image */}
          <Col md="6" className="text-center">
            <img
              src={TeamImage}
              alt="Team"
              className="whychooseus-image"
            />
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default WhyChooseUsSection;
